import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController, NavParams, ToastController } from '@ionic/angular';
import { Share } from '@capacitor/share';
import { DateTimeService } from 'src/app/services/date-time.service';
import { AuthService } from 'src/app/services/auth.service';
import { CloudfunctriggersService } from 'src/app/services/cloudfunctriggers.service';
import { NetworkStatusService } from 'src/app/services/network-status.service';
import { ToastServiceService } from 'src/app/services/toast-service.service';
import { LoadingService } from 'src/app/services/loading.service';
import { DayTradingHours, Shop, Outlet } from 'src/app/models/interfaces';
import { DatabaseService } from 'src/app/services/database.service';
import { YumdealzUserService } from 'src/app/services/yumdealz-user.service';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { TranslationService } from 'src/app/services/translation.service';
import { OutletDealzService } from 'src/app/services/outlet-dealz.service';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { SwiperOptions,Scrollbar } from 'swiper';
// install Swiper modules
SwiperCore.use([Scrollbar]);

@Component({
  selector: 'app-shop',
  templateUrl: './shop.page.html',
  styleUrls: ['./shop.page.scss'],
})
export class ShopPage implements OnInit {
  shop: Shop;
  @Input() shopOutlets:Outlet[]
  @ViewChild('swiper', { static: true }) swiper?: SwiperComponent;
  outletSwiperConfig: SwiperOptions = {
    slidesPerView:1.1,
    centeredSlides:false,
    centeredSlidesBounds:true,
    scrollbar:false,
    flipEffect:{
      transformEl:'ion-card'
    }
  };
  constructor(
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public loadingService: LoadingService,
    public router: Router,
    public outletsDealzService: OutletDealzService,
    public assetLinksService: AssetlinksService,
    public authService: AuthService,
    public toastCtrl: ToastController,
    public cloudTriggers: CloudfunctriggersService,
    public dateTimeService: DateTimeService,
    public navParams: NavParams,
    private yumDealzUserService: YumdealzUserService,
    public toasts: ToastServiceService,
    public networkStatusService: NetworkStatusService,
    private dbService: DatabaseService,
    private ts: TranslationService,
  ) { }

  async ngOnInit() {
  }

  onSwiper(params) {
    const [swiper] = params;
    console.log(swiper);
  }
  
  onBeforeTransitionStart(params) {
    const [swiper, speed, internal] = params;
    console.log('beforeTransitionStart, speed: ' + speed);
  }

  


  share() {
    Share.share({
      text: this.shop.name +' '+ this.ts.getLocalizedValue('RESTAURANT_PAGE.SHOP_GIVING_OUT_LOYALTY_CARDS') + '!',
      title: this.ts.getLocalizedValue('RESTAURANT_PAGE.SHOP_ON_YUMDEALZ'),
      url: `https://app.yumdealz.com?shop=${this.shop.id}`,
      dialogTitle: this.ts.getLocalizedValue('RESTAURANT_PAGE.SHARE_DEAL')
    }
    )
  }



  return(data = null) {
    this.modalCtrl.dismiss();
  }

  async like() {
    // if(!this.yumDealzUserService.getUser().likedSpecials.includes(this.special.id)){
    //   let alert = await this.alertCtrl.create({
    //     header:'Like this?',
    //     message:'Let the restaurant know by giving their deal a like',
    //     cssClass:`custom-alert-shape`,
    //     mode:'ios',
    //     buttons:[
    //       {
    //         text:'not now',
    //         role:'cancel',
    //       },
    //       {
    //         text:'Like',
    //         handler:async()=>{
    //           await this.loadingService.showOrContinueShowingLoading();
    //           this.cloudTriggers.likeSpecial(this.special,this.yumDealzUserService.getUser()).then(async()=>{
    //             this.special.likes? this.special.likes= this.special.likes+1:this.special.likes=1
    //              this.yumDealzUserService.refreshUser().then(async()=>{
    //               await this.loadingService.hideLoading();
    //               await this.toasts.showToast('Thanks!','Liked deal')
    //             }).catch(async (err)=>{
    //               console.log(err);
    //               await this.loadingService.hideLoading();
    //             })
    //           }).catch(async (err)=>{
    //             await this.loadingService.hideLoading();
    //             await this.toasts.showToast('Are you offline?','Failed to like deal.')
    //           })
    //         }
    //       }
    //     ]
    //   })
    //   await alert.present();
    // }else{
    //   await this.toasts.showToast('Thanks again!','You already liked this deal')
    // }
  }


  sendMail() {
    try {
      location.href = `mailto:${this.shop.email}`;
    } catch (error) {
      this.toasts.showToast('', this.ts.getLocalizedValue('RESTAURANT_PAGE.COULD_NOT_OPEN_MAIL_APP'));
    }
  }

  call() {
    try {
      window.open(`tel:${this.shop.contact_number}`);
    } catch (error) {
      console.log(error);
      this.toasts.showErrorToast(this.ts.getLocalizedValue('RESTAURANT_PAGE.COULD_NOT_CALL'))
    }
  }

  async viewMap() {
    let googlemaps = `https://www.google.com/maps/search/?api=1&query=${this.shop.lat},${this.shop.lng}`
    try {
      window.open(googlemaps, '_system', 'location=yes');
    } catch (error) {
      this.toasts.showToast('', this.ts.getLocalizedValue('RESTAURANT_PAGE.COULD_NOT_OPEN_GOOGLE_MAPS'))
    }
  }

  //can remove this eventually as validation in merchant portal should
  //not allow non international format
  giveIntContactNumber(contactNumber: string) {
    let indexZero = '+27'
    let contactNumberSplit = contactNumber.split('');
    contactNumberSplit[0] = indexZero;
    let contactNumberNew = contactNumberSplit.join('');
    return contactNumberNew
  }

  openWhatsapp() {
    try {
      let SAIntNumber = this.shop.contact_number[0] == '+' ? this.shop.contact_number : this.giveIntContactNumber(this.shop.contact_number)
      let msg = encodeURI(this.ts.getLocalizedValue('RESTAURANT_PAGE.WHATSAPP_DEFAULT_MESSAGE') + ':');
      window.open(`https://wa.me/${SAIntNumber}?text=${msg}`, '_system', 'location=yes');
    } catch (error) {
      this.toasts.showToast('', this.ts.getLocalizedValue('RESTAURANT_PAGE.COULD_NOT_OPEN_WHATSAPP'))
    }
  }

  openFacebookPage() {
    try {
      window.open(this.shop.facebook, '_system', 'location=yes')
    } catch (error) {
      this.toasts.showToast('', this.ts.getLocalizedValue('RESTAURANT_PAGE.COULD_NOT_OPEN_FACEBOOK_PAGE'))
    }
  }

  openInstaPage() {
    try {
      window.open(this.shop.instagram, '_system', 'location=yes')
    } catch (error) {
      this.toasts.showToast('', this.ts.getLocalizedValue('RESTAURANT_PAGE.COULD_NOT_OPEN_INSTAGRAM_PAGE'))
    }
  }

  viewReviews() {
    this.toasts.showToast(this.ts.getLocalizedValue('RESTAURANT_PAGE.REVIEW_FUNCTIONALITY_PLANNED_FOR_FUTURE_UPDATE'), this.ts.getLocalizedValue('COMING SOON') + '!')
  }

  openWebsite() {
    try {
      window.open(this.shop.website, '_system', 'location=yes')
    } catch (error) {
      this.toasts.showToast('', this.ts.getLocalizedValue('RESTAURANT_PAGE.COULD_NOT_OPEN_WEBSITE'))
    }
  }


}
